export default __webpack_public_path__ + "static/media/0.310f47b0.png";